import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { IconTrash, IconSave } from "./icons";
import { iconBtn } from "./constants";
import { colors, shadows, btn, modal } from "../../../../style/common/partnerStyle";
import { getMatchHighlight } from "./index";

class FixtureRound extends PureComponent {
  debounceTimeouts = {};
  state = {
    scorePopup: null,
    showAddCourtInput: {}, // { [matchKey]: true }
    newCourtName: {}, // { [matchKey]: "" }
  };

  static propTypes = {
    round: PropTypes.object.isRequired,
    roundIndex: PropTypes.number.isRequired,
    grp: PropTypes.number.isRequired,
    fixtures: PropTypes.array.isRequired,
    team_list: PropTypes.array.isRequired,
    groups: PropTypes.array,
    venues: PropTypes.array,
    competition_game: PropTypes.object,
    knockout_matches_created: PropTypes.bool,
    onHandleTeamChange: PropTypes.func.isRequired,
    onHandleFixtureCourt: PropTypes.func.isRequired,
    onHandleDateTimePicker: PropTypes.func.isRequired,
    onOpenPopup: PropTypes.func.isRequired,
    onSaveNewMatch: PropTypes.func.isRequired,
    onRemoveUnsavedMatch: PropTypes.func.isRequired,
    onSaveNewRound: PropTypes.func.isRequired,
    onRemoveUnsavedRound: PropTypes.func.isRequired,
    onAddMatch: PropTypes.func.isRequired,
    onUpdateMatch: PropTypes.func.isRequired,
    onSaveScore: PropTypes.func.isRequired,
  };

  render() {
    const {
      round,
      roundIndex,
      grp,
      fixtures,
      team_list,
      groups,
      venues,
      courts,
      competition_game,
      knockout_matches_created,
      onHandleTeamChange,
      onHandleFixtureCourt,
      onHandleDateTimePicker,
      onOpenPopup,
      onSaveNewMatch,
      onRemoveUnsavedMatch,
      onSaveNewRound,
      onRemoveUnsavedRound,
      onAddMatch,
      onUpdateMatch,
      onSaveScore,
    } = this.props;
    const hasUnsavedMatches = round.matches.some(function (m) { return !m.id || m.have_changes; });

    const dropdownStyle = {
      flex: "1 0 150px",
      minWidth: 120,
      padding: "8px 10px",
      border: `1px solid ${colors.border}`,
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "inherit",
      color: colors.text,
      background: colors.surface,
      outline: "none",
    };

    const { scorePopup } = this.state;

    // Helper to handle add court input visibility per match
    const handleShowAddCourtInput = (key) => {
      this.setState((prev) => ({
        showAddCourtInput: { ...prev.showAddCourtInput, [key]: true },
        newCourtName: { ...prev.newCourtName, [key]: "" },
      }));
    };

    const handleCourtNameChange = (e, key) => {
      const value = e.target.value;
      this.setState((prev) => ({
        newCourtName: { ...prev.newCourtName, [key]: value },
      }), () => {
        // Debounce: clear previous timeout
        if (this.debounceTimeouts[key]) clearTimeout(this.debounceTimeouts[key]);
        // Set new timeout
        this.debounceTimeouts[key] = setTimeout(() => {
          const name = this.state.newCourtName[key] && this.state.newCourtName[key].trim();
          if (name) {
            this.props.onHandleFixtureCourt({ target: { value: name } }, this.props.grp, this.props.roundIndex, key);
            this.setState((prev) => ({
              showAddCourtInput: { ...prev.showAddCourtInput, [key]: false },
              newCourtName: { ...prev.newCourtName, [key]: "" },
            }));
          }
        }, 1000);
      });
    };

    // No handleSaveCourt needed. Use onHandleFixtureCourt directly on input change or save.

    const parseSessionStart = (str) => {
      if (!str) return Infinity;
      try {
        const [datePart, timePart, meridiem] = str.trim().split(" ");
        const [day, month, year] = datePart.split("/");
        let [h, m] = timePart.split(":").map(Number);
        if (meridiem === "PM" && h !== 12) h += 12;
        if (meridiem === "AM" && h === 12) h = 0;
        return new Date(+year, +month - 1, +day, h, m).getTime();
      } catch (_) {
        return Infinity;
      }
    };

    const matchesList = round.matches
      .map((m, idx) => ({ match: m, origIdx: idx }));

    return (
      <div style={{ marginBottom: 28 }}>
        {scorePopup && (
          <div
            style={{
              position: "fixed", inset: 0,
              background: "rgba(17,24,39,0.45)",
              zIndex: 1000,
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
            onClick={() => this.setState({ scorePopup: null })}
          >
            <div
              style={{
                background: colors.surface,
                borderRadius: 16,
                width: 360,
                maxWidth: "92vw",
                boxShadow: shadows.modal,
                overflow: "hidden",
                fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  padding: "18px 24px 14px",
                  borderBottom: `1px solid ${colors.border}`,
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                }}
              >
                <span style={{ fontWeight: 700, fontSize: 15, color: colors.text }}>
                  Match Score
                </span>
                <button
                  onClick={() => this.setState({ scorePopup: null })}
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    color: colors.muted, fontSize: 20, lineHeight: 1, padding: 0,
                  }}
                  title="Close"
                >
                  &#x2715;
                </button>
              </div>

              <div style={{ padding: "24px 24px 20px" }}>
                <div style={{ display: "flex", alignItems: "flex-end", gap: 0 }}>
                  <div
                    style={{
                      flex: 1, display: "flex", flexDirection: "column",
                      alignItems: "center", justifyContent: "space-between",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11, fontWeight: 700, letterSpacing: "0.05em",
                        textTransform: "uppercase", color: colors.muted,
                        textAlign: "center", maxWidth: 120, wordBreak: "break-word",
                        lineHeight: 1.5,
                        minHeight: 34,
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}
                    >
                      {scorePopup.team1Name}
                    </div>
                    <input
                      type="number" min="0"
                      value={scorePopup.t1}
                      onChange={(e) =>
                        this.setState({ scorePopup: { ...scorePopup, t1: e.target.value } })
                      }
                      style={{
                        width: 80, textAlign: "center",
                        padding: "12px 6px",
                        fontSize: 32, fontWeight: 700, lineHeight: 1,
                        border: `2px solid ${colors.border}`,
                        borderRadius: 10,
                        color: colors.text, background: colors.bg,
                        outline: "none", fontFamily: "inherit",
                        boxSizing: "border-box",
                      }}
                      onFocus={(e) => { e.target.style.borderColor = colors.brand; }}
                      onBlur={(e) => { e.target.style.borderColor = colors.border; }}
                    />
                  </div>

                  <div
                    style={{
                      width: 40, display: "flex", alignItems: "center",
                      justifyContent: "center",
                      height: 58,
                      fontSize: 18, fontWeight: 700, color: colors.muted,
                    }}
                  >
                    –
                  </div>

                  <div
                    style={{
                      flex: 1, display: "flex", flexDirection: "column",
                      alignItems: "center", justifyContent: "space-between",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11, fontWeight: 700, letterSpacing: "0.05em",
                        textTransform: "uppercase", color: colors.muted,
                        textAlign: "center", maxWidth: 120, wordBreak: "break-word",
                        lineHeight: 1.5,
                        minHeight: 34,
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}
                    >
                      {scorePopup.team2Name}
                    </div>
                    <input
                      type="number" min="0"
                      value={scorePopup.t2}
                      onChange={(e) =>
                        this.setState({ scorePopup: { ...scorePopup, t2: e.target.value } })
                      }
                      style={{
                        width: 80, textAlign: "center",
                        padding: "12px 6px",
                        fontSize: 32, fontWeight: 700, lineHeight: 1,
                        border: `2px solid ${colors.border}`,
                        borderRadius: 10,
                        color: colors.text, background: colors.bg,
                        outline: "none", fontFamily: "inherit",
                        boxSizing: "border-box",
                      }}
                      onFocus={(e) => { e.target.style.borderColor = colors.brand; }}
                      onBlur={(e) => { e.target.style.borderColor = colors.border; }}
                    />
                  </div>
                </div>
              </div>

              <div
                style={{
                  ...modal.footer,
                  padding: "14px 24px",
                  marginTop: 0,
                }}
              >
                <button
                  style={{ ...btn.cancel, fontFamily: "inherit" }}
                  onClick={() => this.setState({ scorePopup: null })}
                >
                  Cancel
                </button>
                <button
                  style={{ ...btn.primary, fontFamily: "inherit" }}
                  onClick={() => {
                    onSaveScore(
                      scorePopup.matchId, scorePopup.grp,
                      scorePopup.roundIndex, scorePopup.key,
                      scorePopup.t1, scorePopup.t2,
                    );
                    this.setState({ scorePopup: null });
                  }}
                >
                  Save Score
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 12,
          }}
        >
          <div style={{ fontSize: 16, fontWeight: 700, color: colors.text }}>
            Round {round.round_no}
            {hasUnsavedMatches && (
              <span
                style={{
                  marginLeft: 8,
                  fontSize: 11,
                  fontWeight: 500,
                  color: "#f59e0b",
                  background: "#fef3c7",
                  border: "1px solid #fde68a",
                  borderRadius: 4,
                  padding: "1px 6px",
                  verticalAlign: "middle",
                }}
              >
                unsaved
              </span>
            )}
          </div>
        </div>

        {matchesList.map(({ match, origIdx: key }) => {
          const isUiOnlyMatch = !match.id;
          const highlight = getMatchHighlight(match);
          const team1Winner = match.team_one && match.team_one.winner;
          const team2Winner = match.team_two && match.team_two.winner;
          const team1Score =
            match.team1_scores && match.team1_scores[0] !== undefined
              ? match.team1_scores[0]
              : "";
          const team2Score =
            match.team2_scores && match.team2_scores[0] !== undefined
              ? match.team2_scores[0]
              : "";

          return (
            <div
              key={match.id || `new-${key}`}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
                background: highlight.bg,
                border: `2px solid ${highlight.border}`,
                borderRadius: 10,
                padding: "10px 14px",
                marginBottom: 10,
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                transition: "background 0.2s, border-color 0.2s",
              }}
            >
              <select
                name="team_one"
                title="Team 1"
                style={{
                  ...dropdownStyle,
                  borderColor: team1Winner ? colors.brand : colors.border,
                  fontWeight: team1Winner ? 700 : 400,
                  color: team1Winner ? colors.brand : colors.text,
                }}
                value={match.team_one.id}
                onChange={(e) => onHandleTeamChange(e, grp, roundIndex, key, "team_one")}
              >
                <option value="" defaultChecked hidden>Team 1</option>
                {team_list
                  .filter(
                    (team) =>
                      team.group == (groups && groups[grp]) ||
                      team.team_type == "BYE",
                  )
                  .map((tournament_team, i) => (
                    <option key={i} value={tournament_team.id}>
                      {tournament_team.team.name}
                    </option>
                  ))}
              </select>

              <select
                name="team_two"
                title="Team 2"
                style={{
                  ...dropdownStyle,
                  borderColor: team2Winner ? colors.brand : colors.border,
                  fontWeight: team2Winner ? 700 : 400,
                  color: team2Winner ? colors.brand : colors.text,
                }}
                value={match.team_two.id}
                onChange={(e) => onHandleTeamChange(e, grp, roundIndex, key, "team_two")}
              >
                <option value="" defaultChecked hidden>Team 2</option>
                {team_list
                  .filter(
                    (team) =>
                      team.group == (groups && groups[grp]) ||
                      team.team_type == "BYE",
                  )
                  .map((tournament_team, i) => (
                    <option key={i} value={tournament_team.id}>
                      {tournament_team.team.name}
                    </option>
                  ))}
              </select>

              {match.team_one.name != "BYE" && match.team_two.name != "BYE" ? (
                <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 100 }}>
                  {this.state.showAddCourtInput[key] ? (
                    <div style={{display:'flex'}}>
                      <input
                        type="text"
                        className="court-input"
                        value={this.state.newCourtName[key] || ""}
                        autoFocus
                        placeholder="Court name"
                        style={{
                          ...dropdownStyle,
                          flex: "0 1 120px",
                          minWidth: 60,
                          fontSize: 13,
                          padding:'7px 10px'
                        }}
                        onChange={e => {
                          handleCourtNameChange(e, key);
                        }}
                        // Debounced save, no onBlur or Enter needed
                      />
                      
                      <button
                        style={{
                          marginLeft: 2,
                          background: "none",
                          color: colors.muted,
                          border: "none",
                          borderRadius: 6,
                          padding: "4px 8px",
                          cursor: "pointer",
                          fontSize: 13,
                        }}
                        title="Cancel"
                        onClick={() =>
                          this.setState(prev => ({
                            showAddCourtInput: { ...prev.showAddCourtInput, [key]: false },
                            newCourtName: { ...prev.newCourtName, [key]: "" },
                          }))
                        }
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: 'flex' }}>
                      {(() => {
                        const selectedCourtRaw =
                          fixtures[grp].group_round_robin[roundIndex].matches[key]["court"];

                        const selectedCourtValue =
                          typeof selectedCourtRaw === "object" && selectedCourtRaw !== null
                            ? selectedCourtRaw.id
                            : selectedCourtRaw;

                        const selectedCourtLabel =
                          typeof selectedCourtRaw === "object" && selectedCourtRaw !== null
                            ? selectedCourtRaw.name
                            : selectedCourtRaw;

                        const exists = Object.values(courts).some(
                          c => String(c.id) === String(selectedCourtValue)
                        );

                        return (
                          <div>
                            <select
                              name="court"
                              title="Court"
                              style={{ ...dropdownStyle, flex: "0 1 120px", minWidth: 60 }}
                              value={selectedCourtValue || ""}
                              onChange={(e) =>
                                onHandleFixtureCourt(e, grp, roundIndex, key)
                              }
                            >
                              <option value="">Court</option>

                              {Object.keys(courts).map((k, i) => (
                                <option key={i} value={courts[k].id}>
                                  {courts[k].name}
                                </option>
                              ))}

                              {selectedCourtValue && !exists && (
                                <option value={selectedCourtValue} style={{ fontStyle: 'italic' }}>
                                  {selectedCourtLabel || "New Court"} (new)
                                </option>
                              )}
                            </select>

                            <button
                              style={{
                                marginLeft: 2,
                                background: "none",
                                color: colors.brand,
                                border: "none",
                                borderRadius: 6,
                                padding: "0px",
                                cursor: "pointer",
                                fontSize: 18,
                                lineHeight: 1,
                              }}
                              title="Add new court"
                              onClick={() => handleShowAddCourtInput(key)}
                            >
                              ＋
                            </button>
                          </div>
                        );
                      })()}
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ flex: "0 1 130px" }} />
              )}

              {match.team_one.name != "BYE" && match.team_two.name != "BYE" ? (
                <Datetime
                  inputProps={{
                    placeholder: "Match date",
                    title: "Match date",
                    style: {
                      ...dropdownStyle,
                      flex: "0 1 120px",
                      minWidth: 110,
                      borderColor: match.found_clash ? "#f59e0b" : colors.border,
                    },
                  }}
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  onChange={(date) => onHandleDateTimePicker(date, grp, roundIndex, key, "date")}
                  value={match.session_start ? match.session_start.split(" ")[0] : ""}
                />
              ) : (
                <div style={{ flex: "0 1 120px" }} />
              )}

              {match.team_one.name != "BYE" && match.team_two.name != "BYE" ? (
                <Datetime
                  inputProps={{
                    placeholder: "Start time",
                    title: "Start time",
                    style: {
                      ...dropdownStyle,
                      flex: "0 1 110px",
                      minWidth: 100,
                      borderColor: match.found_clash ? "#f59e0b" : colors.border,
                    },
                  }}
                  dateFormat={false}
                  timeFormat="hh:mm A"
                  onChange={(date) => onHandleDateTimePicker(date, grp, roundIndex, key, "time")}
                  value={
                    match.session_start
                      ? match.session_start.split(" ").slice(1).join(" ")
                      : ""
                  }
                />
              ) : (
                <div style={{ flex: "0 1 110px" }} />
              )}

              {!isUiOnlyMatch &&
                match.team_one.name != "BYE" &&
                match.team_two.name != "BYE" &&
                competition_game ? (
                competition_game.id == 1 ? (
                  <button
                    title="Enter football score"
                    disabled={knockout_matches_created}
                    style={{
                      ...(team1Score !== "" ? btn.primarySm : btn.outlineSm),
                      fontFamily: "inherit", whiteSpace: "nowrap",
                    }}
                    onClick={() => onOpenPopup(grp, roundIndex, key)}
                  >
                    {team1Score !== "" ? `${team1Score} – ${team2Score}` : "Add Score"}
                  </button>
                ) : (
                  <button
                    title="Enter score"
                    style={{
                      ...(team1Score !== "" ? btn.primarySm : btn.outlineSm),
                      fontFamily: "inherit", whiteSpace: "nowrap",
                    }}
                    onClick={() =>
                      this.setState({
                        scorePopup: {
                          matchId: match.id,
                          grp,
                          roundIndex,
                          key,
                          t1: team1Score !== "" ? String(team1Score) : "",
                          t2: team2Score !== "" ? String(team2Score) : "",
                          team1Name: match.team_one.name || "Team 1",
                          team2Name: match.team_two.name || "Team 2",
                        },
                      })
                    }
                  >
                    {team1Score !== "" ? `${team1Score} – ${team2Score}` : "Add Score"}
                  </button>
                )
              ) : null}

              {isUiOnlyMatch ? (
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <button
                    title="Save match to backend"
                    style={iconBtn(colors.brand)}
                    onClick={() => onSaveNewMatch(grp, roundIndex, key)}
                  >
                    <IconSave size={16} />
                  </button>
                  <button
                    title="Remove this match"
                    style={iconBtn(colors.muted)}
                    onClick={() => onRemoveUnsavedMatch(grp, roundIndex, key)}
                  >
                    <IconTrash size={16} />
                  </button>
                </div>
              ) : match.have_changes ? (
                <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <button
                    title="Save changes"
                    style={iconBtn('#22c122')}
                    onClick={() => onUpdateMatch(match.id, grp, roundIndex, key)}
                  >
                    <IconSave size={16} />
                  </button>
                  <a
                    href={`../../#/crud/deleteMatch/${match.id}`}
                    title="Delete this match"
                    style={{ color: colors.muted, lineHeight: 0 }}
                  >
                    <IconTrash size={16} />
                  </a>
                </div>
              ) : (
                <a
                  href={`../../#/crud/deleteMatch/${match.id}`}
                  title="Delete this match"
                  style={{ color: colors.muted, lineHeight: 0 }}
                >
                  <IconTrash size={16} />
                </a>
              )}
            </div>
          );
        })}

        <div
          style={{
            color: colors.brand,
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            paddingLeft: 4,
            marginTop: 4,
          }}
          onClick={(e) => onAddMatch(e, grp, roundIndex)}
        >
          Add Match +
        </div>
      </div>
    );
  }
}

export default FixtureRound;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureScreen/FixtureRound.js